import { api } from '../createApi';
import { TagType } from '../TagType';

export const TAG_ROUTINGS_BY_LIST = { type: TagType.Routings, id: 'LIST' };
export const TAG_ROUTING_CONFIGURATION = {
  type: TagType.Routings,
  id: 'CONFIG',
};

api.enhanceEndpoints({
  addTagTypes: [TagType.Routings as TagType],
  endpoints: {
    searchRouting: {
      providesTags: [TAG_ROUTINGS_BY_LIST],
    },
    createRouting: {
      invalidatesTags: [TAG_ROUTINGS_BY_LIST],
    },
    updateRouting: {
      invalidatesTags: [TAG_ROUTINGS_BY_LIST],
    },
    deleteRouting: {
      invalidatesTags: [TAG_ROUTINGS_BY_LIST],
    },
    getRoutingConfiguration: {
      providesTags: [TAG_ROUTING_CONFIGURATION],
    },
    patchRoutingConfiguration: {
      invalidatesTags: [TAG_ROUTING_CONFIGURATION],
    },
  },
});
